<template>
  <div
    role="dialog"
    aria-label="Unibuddy chat window"
    aria-modal="true"
    class="f-cover bg-accent-3-90 z-20"
  >
    <div
      class="r-cover py-16 p-x lg:px-64 overflow-y-auto scrollbar"
      @click.self="$store.commit('toggleUnibuddyState')"
    >
      <iframe
        id="unibuddy-iframe"
        :src="unibuddy"
        type="text/html"
        scrolling="yes"
        width="100%"
        height="100%"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        title="Unibuddy - University of Edinburgh"
      />

      <Button
        title="Close Unibuddy chat"
        type="button"
        icon="CloseIcon"
        iconcolor="white"
        :iconsize="mobile ? '32px' : '38px'"
        class="absolute top-2 right-2 lg:top-4 lg:right-6 focus-a"
        @buttonClick="$store.commit('toggleUnibuddyState')"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '@/components/buttons/Button.vue'

export default {
  name: 'Unibuddy',

  components: {
    Button
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters(['unibuddy'])
  }
}
</script>
